// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './components/App'
import { createRouter } from './router'
import { createStore } from './store'
import { sync } from 'vuex-router-sync'

import axios from 'axios'
import VueAxios from 'vue-axios'

import * as log from 'loglevel'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import './assets/theme.scss'

import VueHighlightJS from 'vue-highlightjs'
import 'highlight.js/styles/monokai-sublime.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faCoffee,
  faArrowLeft,
  faBars
} from '@fortawesome/free-solid-svg-icons'

import Vue2Filters from 'vue2-filters'

Vue.use(VueAxios, axios)
Vue.use(VueMaterial)
Vue.use(VueHighlightJS)
Vue.use(Vue2Filters)

Vue.component('font-awesome-icon', FontAwesomeIcon)

library.add(faCoffee)
library.add(faArrowLeft)
library.add(faBars)

Vue.config.productionTip = false
const isProduction = process.env.NODE_ENV === 'production'

if (isProduction) {
  log.disableAll()
} else {
  axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
  log.enableAll()
}

window.log = log

export async function createApp (context) {
  const router = createRouter()
  const store = createStore(axios)

  sync(store, router)

  await store.dispatch('init')

  const app = new Vue({
    router,
    store,
    mixins: [
      Vue2Filters.mixin
    ],
    components: { App },
    template: '<App/>',
    ...App
  })

  return {
    app,
    router,
    store
  }
}



// WEBPACK FOOTER //
// ./src/app.js